module.exports = __webpack_public_path__ + "static/media/comb.a3394f8f.webp";